/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import ActionButtonList from '../components/molecules/ActionButtonList/ActionButtonList.tsx';
import ActionsStatistics from '../components/molecules/ActionsStatistics/ActionsStatistics.tsx';
import AddToBasket from '../components/molecules/AddToBasket/AddToBasket.tsx';
import BackToSearch from '../components/molecules/BackToSearch/BackToSearch.tsx';
import BasicImage from '../components/molecules/BasicImage/BasicImage.tsx';
import BasicInformation from '../components/molecules/BasicInformation/BasicInformation.tsx';
import BasicText from '../components/molecules/BasicText/BasicText.tsx';
import Breadcrumb from '../components/molecules/Breadcrumb/Breadcrumb.tsx';
import ButtonGroup from '../components/molecules/ButtonGroup/ButtonGroup.tsx';
import CallToActionContent from '../components/molecules/CallToActionContent/CallToActionContent.tsx';
import CallToActionImage from '../components/molecules/CallToActionImage/CallToActionImage.tsx';
import ContentCard from '../components/molecules/ContentCard/ContentCard.tsx';
import ContentModal from '../components/molecules/ContentModal/ContentModal.tsx';
import DealerContactInformation from '../components/molecules/DealerContactInformation/DealerContactInformation.tsx';
import FindNearestDealerForm from '../components/molecules/FindNearestDealerForm/FindNearestDealerForm.tsx';
import FourColumnLayout from '../components/molecules/FourColumnLayout/FourColumnLayout.tsx';
import FourContentColumnLayout from '../components/molecules/FourContentColumnLayout/FourContentColumnLayout.tsx';
import GrayTopNavigationBar from '../components/molecules/GrayTopNavigationBar/GrayTopNavigationBar.tsx';
import Grid from '../components/molecules/Grid/Grid.tsx';
import GridCardContainer from '../components/molecules/GridCardContainer/GridCardContainer.tsx';
import HeroBanner from '../components/molecules/HeroBanner/HeroBanner.tsx';
import HeroBannerWithCallToAction from '../components/molecules/HeroBannerWithCallToAction/HeroBannerWithCallToAction.tsx';
import HeroBannerWithTitleAbove from '../components/molecules/HeroBannerWithTitleAbove/HeroBannerWithTitleAbove.tsx';
import HeroBannerWithUSP from '../components/molecules/HeroBannerWithUSP/HeroBannerWithUSP.tsx';
import HeroImage from '../components/molecules/HeroImage/HeroImage.tsx';
import HighlightedContentBlock from '../components/molecules/HighlightedContentBlock/HighlightedContentBlock.tsx';
import Iframe from '../components/molecules/Iframe/Iframe.tsx';
import LanguageSwitcher from '../components/molecules/LanguageSwitcher/LanguageSwitcher.tsx';
import LoginOrRegister from '../components/molecules/LoginOrRegister/LoginOrRegister.tsx';
import LoyaltyPointBalanceBanner from '../components/molecules/LoyaltyPointBalanceBanner/LoyaltyPointBalanceBanner.tsx';
import LoyaltyProgramLogo from '../components/molecules/LoyaltyProgramLogo/LoyaltyProgramLogo.tsx';
import Menu from '../components/molecules/Menu/Menu.tsx';
import MenuList from '../components/molecules/MenuList/MenuList.tsx';
import MenuListAction from '../components/molecules/MenuListAction/MenuListAction.tsx';
import MenuResponsive from '../components/molecules/MenuResponsive/MenuResponsive.tsx';
import MobileBreadcrumb from '../components/molecules/MobileBreadcrumb/MobileBreadcrumb.tsx';
import MyAccountNavigation from '../components/molecules/MyAccountNavigation/MyAccountNavigation.tsx';
import Navigation from '../components/molecules/Navigation/Navigation.tsx';
import NoResults from '../components/molecules/NoResults/NoResults.tsx';
import OneColumnLayout from '../components/molecules/OneColumnLayout/OneColumnLayout.tsx';
import OneContentColumnLayout from '../components/molecules/OneContentColumnLayout/OneContentColumnLayout.tsx';
import Overlay from '../components/molecules/Overlay/Overlay.tsx';
import PaginationControls from '../components/molecules/PaginationControls/PaginationControls.tsx';
import PaginationPageNumbers from '../components/molecules/PaginationPageNumbers/PaginationPageNumbers.tsx';
import PartLine from '../components/molecules/PartLine/PartLine.tsx';
import PartPrice from '../components/molecules/PartPrice/PartPrice.tsx';
import PartPromotions from '../components/molecules/PartPromotions/PartPromotions.tsx';
import PartnerTileList from '../components/molecules/PartnerTileList/PartnerTileList.tsx';
import PlansAndOtherServices from '../components/molecules/PlansAndOtherServices/PlansAndOtherServices.tsx';
import ProductOrServiceTile from '../components/molecules/ProductOrServiceTile/ProductOrServiceTile.tsx';
import RemoveCategoryFilterButton from '../components/molecules/RemoveCategoryFilterButton/RemoveCategoryFilterButton.tsx';
import RequestAccountSelectDealer from '../components/molecules/RequestAccountSelectDealer/RequestAccountSelectDealer.tsx';
import RequestAccountSelectedDealer from '../components/molecules/RequestAccountSelectedDealer/RequestAccountSelectedDealer.tsx';
import ResponsiveWrapper from '../components/molecules/ResponsiveWrapper/ResponsiveWrapper.tsx';
import RewardsOverviewFilterControls from '../components/molecules/RewardsOverviewFilterControls/RewardsOverviewFilterControls.tsx';
import RewardsRedeemRewardSidepanel from '../components/molecules/RewardsRedeemRewardSidepanel/RewardsRedeemRewardSidepanel.tsx';
import SearchBar from '../components/molecules/SearchBar/SearchBar.tsx';
import SearchServicePartners from '../components/molecules/SearchServicePartners/SearchServicePartners.tsx';
import ServicePlansCoverageSummary from '../components/molecules/ServicePlansCoverageSummary/ServicePlansCoverageSummary.tsx';
import ServicePlansCoverageSummaryBullets from '../components/molecules/ServicePlansCoverageSummaryBullets/ServicePlansCoverageSummaryBullets.tsx';
import ServicePlansDetails from '../components/molecules/ServicePlansDetails/ServicePlansDetails.tsx';
import SitecoreButton from '../components/molecules/SitecoreButton/SitecoreButton.tsx';
import SitecoreLink from '../components/molecules/SitecoreLink/SitecoreLink.tsx';
import SitecoreText from '../components/molecules/SitecoreText/SitecoreText.tsx';
import SocialShareButton from '../components/molecules/SocialShareButton/SocialShareButton.tsx';
import SubNavigationMenu from '../components/molecules/SubNavigationMenu/SubNavigationMenu.tsx';
import SummaryList from '../components/molecules/SummaryList/SummaryList.tsx';
import Supersession from '../components/molecules/Supersession/Supersession.tsx';
import Tab from '../components/molecules/Tab/Tab.tsx';
import Table from '../components/molecules/Table/Table.tsx';
import ThreeColumnLayout from '../components/molecules/ThreeColumnLayout/ThreeColumnLayout.tsx';
import ThreeContentColumnLayout from '../components/molecules/ThreeContentColumnLayout/ThreeContentColumnLayout.tsx';
import Title from '../components/molecules/Title/Title.tsx';
import TitleBar from '../components/molecules/TitleBar/TitleBar.tsx';
import Toast from '../components/molecules/Toast/Toast.tsx';
import Tooltip from '../components/molecules/Tooltip/Tooltip.tsx';
import TwoColumnLayout from '../components/molecules/TwoColumnLayout/TwoColumnLayout.tsx';
import TwoContentColumnLayout from '../components/molecules/TwoContentColumnLayout/TwoContentColumnLayout.tsx';
import VehicleDetailNotifications from '../components/molecules/VehicleDetailNotifications/VehicleDetailNotifications.tsx';
import VehicleGrid from '../components/molecules/VehicleGrid/VehicleGrid.tsx';
import VehicleRmDocuments from '../components/molecules/VehicleRmDocuments/VehicleRmDocuments.tsx';
import VehicleSearch from '../components/molecules/VehicleSearch/VehicleSearch.tsx';
import YouTubeVideo from '../components/molecules/YouTubeVideo/YouTubeVideo.tsx';
import AccountOverview from '../components/organisms/AccountOverview/AccountOverview.tsx';
import AnchorMenu from '../components/organisms/AnchorMenu/AnchorMenu.tsx';
import ArticleHighlights from '../components/organisms/ArticleHighlights/ArticleHighlights.tsx';
import AssemblyBasicInformation from '../components/organisms/AssemblyBasicInformation/AssemblyBasicInformation.tsx';
import AssemblyBillOfMaterial from '../components/organisms/AssemblyBillOfMaterial/AssemblyBillOfMaterial.tsx';
import AssemblyImages from '../components/organisms/AssemblyImages/AssemblyImages.tsx';
import CallToAction from '../components/organisms/CallToAction/CallToAction.tsx';
import CallToActionCentered from '../components/organisms/CallToActionCentered/CallToActionCentered.tsx';
import CallToActionGridWithImage from '../components/organisms/CallToActionGridWithImage/CallToActionGridWithImage.tsx';
import CallToActionWithImage from '../components/organisms/CallToActionWithImage/CallToActionWithImage.tsx';
import CallToActionWithImageBase from '../components/organisms/CallToActionWithImageBase/CallToActionWithImageBase.tsx';
import CompanyProfile from '../components/organisms/CompanyProfile/CompanyProfile.tsx';
import ContentSlider from '../components/organisms/ContentSlider/ContentSlider.tsx';
import CookieConsent from '../components/organisms/CookieConsent/CookieConsent.tsx';
import CookieConsentBase from '../components/organisms/CookieConsentBase/CookieConsentBase.tsx';
import CookieConsentPopup from '../components/organisms/CookieConsentPopup/CookieConsentPopup.tsx';
import DafPortalConnect from '../components/organisms/DafPortalConnect/DafPortalConnect.tsx';
import DealerContactInformationBanner from '../components/organisms/DealerContactInformationBanner/DealerContactInformationBanner.tsx';
import DealerLocator from '../components/organisms/DealerLocator/DealerLocator.tsx';
import DealerPartBasicInformation from '../components/organisms/DealerPartBasicInformation/DealerPartBasicInformation.tsx';
import DealerPartCrossReferences from '../components/organisms/DealerPartCrossReferences/DealerPartCrossReferences.tsx';
import DealerPartImagesCarousel from '../components/organisms/DealerPartImagesCarousel/DealerPartImagesCarousel.tsx';
import DealerPartSpecifications from '../components/organisms/DealerPartSpecifications/DealerPartSpecifications.tsx';
import DoubleImageBlock from '../components/organisms/DoubleImageBlock/DoubleImageBlock.tsx';
import EmptyGridBox from '../components/organisms/EmptyGridBox/EmptyGridBox.tsx';
import FactSheet from '../components/organisms/FactSheet/FactSheet.tsx';
import FinancialProfile from '../components/organisms/FinancialProfile/FinancialProfile.tsx';
import FindNearestDealer from '../components/organisms/FindNearestDealer/FindNearestDealer.tsx';
import FindNearestDealerBlock from '../components/organisms/FindNearestDealerBlock/FindNearestDealerBlock.tsx';
import Footer from '../components/organisms/Footer/Footer.tsx';
import GenericContentSlider from '../components/organisms/GenericContentSlider/GenericContentSlider.tsx';
import Header from '../components/organisms/Header/Header.tsx';
import HeroBannerWithPlaceholder from '../components/organisms/HeroBannerWithPlaceholder/HeroBannerWithPlaceholder.tsx';
import HybridLogin from '../components/organisms/HybridLogin/HybridLogin.tsx';
import ImageCarousel from '../components/organisms/ImageCarousel/ImageCarousel.tsx';
import Impersonated from '../components/organisms/Impersonated/Impersonated.tsx';
import KnowledgeBase from '../components/organisms/KnowledgeBase/KnowledgeBase.tsx';
import LoyaltyPointsBalance from '../components/organisms/LoyaltyPointsBalance/LoyaltyPointsBalance.tsx';
import MagazineCallToAction from '../components/organisms/MagazineCallToAction/MagazineCallToAction.tsx';
import MagazineCover from '../components/organisms/MagazineCover/MagazineCover.tsx';
import MagazineProductHighlightDual from '../components/organisms/MagazineProductHighlightDual/MagazineProductHighlightDual.tsx';
import MagazineProductHighlightSingle from '../components/organisms/MagazineProductHighlightSingle/MagazineProductHighlightSingle.tsx';
import MagazineProductHighlightTriple from '../components/organisms/MagazineProductHighlightTriple/MagazineProductHighlightTriple.tsx';
import MagazineTestimonial from '../components/organisms/MagazineTestimonial/MagazineTestimonial.tsx';
import MainNavigation from '../components/organisms/MainNavigation/MainNavigation.tsx';
import Modal from '../components/organisms/Modal/Modal.tsx';
import MultiSupportDashboard from '../components/organisms/MultiSupportDashboard/MultiSupportDashboard.tsx';
import MultisupportUrgentTask from '../components/organisms/MultisupportUrgentTask/MultisupportUrgentTask.tsx';
import MultisupportUrgentTasks from '../components/organisms/MultisupportUrgentTasks/MultisupportUrgentTasks.tsx';
import MyAccount from '../components/organisms/MyAccount/MyAccount.tsx';
import MyFleetDashboard from '../components/organisms/MyFleetDashboard/MyFleetDashboard.tsx';
import MyFleetList from '../components/organisms/MyFleetList/MyFleetList.tsx';
import NewsArticleCard from '../components/organisms/NewsArticleCard/NewsArticleCard.tsx';
import NewsArticleDetail from '../components/organisms/NewsArticleDetail/NewsArticleDetail.tsx';
import NewsArticleHighlights from '../components/organisms/NewsArticleHighlights/NewsArticleHighlights.tsx';
import NewsArticleOverview from '../components/organisms/NewsArticleOverview/NewsArticleOverview.tsx';
import NotificationBar from '../components/organisms/NotificationBar/NotificationBar.tsx';
import NotificationBarContent from '../components/organisms/NotificationBarContent/NotificationBarContent.tsx';
import Paginated from '../components/organisms/Paginated/Paginated.tsx';
import Pagination from '../components/organisms/Pagination/Pagination.tsx';
import PartAlternativeParts from '../components/organisms/PartAlternativeParts/PartAlternativeParts.tsx';
import PartApplicationTable from '../components/organisms/PartApplicationTable/PartApplicationTable.tsx';
import PartApplications from '../components/organisms/PartApplications/PartApplications.tsx';
import PartBasicInformation from '../components/organisms/PartBasicInformation/PartBasicInformation.tsx';
import PartBillOfMaterial from '../components/organisms/PartBillOfMaterial/PartBillOfMaterial.tsx';
import PartCrossReferences from '../components/organisms/PartCrossReferences/PartCrossReferences.tsx';
import PartCrossSellParts from '../components/organisms/PartCrossSellParts/PartCrossSellParts.tsx';
import PartEnvironmentalInfo from '../components/organisms/PartEnvironmentalInfo/PartEnvironmentalInfo.tsx';
import PartImagesCarousel from '../components/organisms/PartImagesCarousel/PartImagesCarousel.tsx';
import PartMaxCoupon from '../components/organisms/PartMaxCoupon/PartMaxCoupon.tsx';
import PartMobileModalLink from '../components/organisms/PartMobileModalLink/PartMobileModalLink.tsx';
import PartMostVisitedSlider from '../components/organisms/PartMostVisitedSlider/PartMostVisitedSlider.tsx';
import PartPromotionsSlider from '../components/organisms/PartPromotionsSlider/PartPromotionsSlider.tsx';
import PartQuantumPrice from '../components/organisms/PartQuantumPrice/PartQuantumPrice.tsx';
import PartSlider from '../components/organisms/PartSlider/PartSlider.tsx';
import PartSpareParts from '../components/organisms/PartSpareParts/PartSpareParts.tsx';
import PartSpecifications from '../components/organisms/PartSpecifications/PartSpecifications.tsx';
import PartSpecificationsTable from '../components/organisms/PartSpecificationsTable/PartSpecificationsTable.tsx';
import PartStockInformationList from '../components/organisms/PartStockInformationList/PartStockInformationList.tsx';
import PartsNavigation from '../components/organisms/PartsNavigation/PartsNavigation.tsx';
import PayWithPointsWrapper from '../components/organisms/PayWithPointsWrapper/PayWithPointsWrapper.tsx';
import PersonalizedGreetingBanner from '../components/organisms/PersonalizedGreetingBanner/PersonalizedGreetingBanner.tsx';
import PointsForMerchandiseWrapper from '../components/organisms/PointsForMerchandiseWrapper/PointsForMerchandiseWrapper.tsx';
import ProductsAndServices from '../components/organisms/ProductsAndServices/ProductsAndServices.tsx';
import ProgressBar from '../components/organisms/ProgressBar/ProgressBar.tsx';
import QuickLinks from '../components/organisms/QuickLinks/QuickLinks.tsx';
import RecommendedPartSlider from '../components/organisms/RecommendedPartSlider/RecommendedPartSlider.tsx';
import RequestAccount from '../components/organisms/RequestAccount/RequestAccount.tsx';
import RequestAccountDealer from '../components/organisms/RequestAccountDealer/RequestAccountDealer.tsx';
import RequestMaintenancePlanWizard from '../components/organisms/RequestMaintenancePlanWizard/RequestMaintenancePlanWizard.tsx';
import RewardsOverview from '../components/organisms/RewardsOverview/RewardsOverview.tsx';
import RewardsOverviewWrapper from '../components/organisms/RewardsOverviewWrapper/RewardsOverviewWrapper.tsx';
import SearchResults from '../components/organisms/SearchResults/SearchResults.tsx';
import ShoppingBasket from '../components/organisms/ShoppingBasket/ShoppingBasket.tsx';
import ShoppingBasketOrderConfirmed from '../components/organisms/ShoppingBasketOrderConfirmed/ShoppingBasketOrderConfirmed.tsx';
import ShoppingBasketPartMostVisitedSlider from '../components/organisms/ShoppingBasketPartMostVisitedSlider/ShoppingBasketPartMostVisitedSlider.tsx';
import ShoppingBasketRecommendedPartSlider from '../components/organisms/ShoppingBasketRecommendedPartSlider/ShoppingBasketRecommendedPartSlider.tsx';
import ShoppingBasketWizard from '../components/organisms/ShoppingBasketWizard/ShoppingBasketWizard.tsx';
import SidePanel from '../components/organisms/SidePanel/SidePanel.tsx';
import SitecoreForm from '../components/organisms/SitecoreForm/SitecoreForm.tsx';
import Slider from '../components/organisms/Slider/Slider.tsx';
import SlideshowHandout from '../components/organisms/SlideshowHandout/SlideshowHandout.tsx';
import SlideshowModal from '../components/organisms/SlideshowModal/SlideshowModal.tsx';
import SocialShareButtons from '../components/organisms/SocialShareButtons/SocialShareButtons.tsx';
import StoreSwitcher from '../components/organisms/StoreSwitcher/StoreSwitcher.tsx';
import TeaserImageTextBlock from '../components/organisms/TeaserImageTextBlock/TeaserImageTextBlock.tsx';
import Testimonial from '../components/organisms/Testimonial/Testimonial.tsx';
import ToastWrapper from '../components/organisms/ToastWrapper/ToastWrapper.tsx';
import UserSettings from '../components/organisms/UserSettings/UserSettings.tsx';
import VehicleDetailFinance from '../components/organisms/VehicleDetailFinance/VehicleDetailFinance.tsx';
import VehicleDetailHeader from '../components/organisms/VehicleDetailHeader/VehicleDetailHeader.tsx';
import VehicleDetailMaintenance from '../components/organisms/VehicleDetailMaintenance/VehicleDetailMaintenance.tsx';
import VehicleDetailServicePlans from '../components/organisms/VehicleDetailServicePlans/VehicleDetailServicePlans.tsx';
import VehicleMaintenanceList from '../components/organisms/VehicleMaintenanceList/VehicleMaintenanceList.tsx';
import VehicleRecallList from '../components/organisms/VehicleRecallList/VehicleRecallList.tsx';
import VehicleSearchBlock from '../components/organisms/VehicleSearchBlock/VehicleSearchBlock.tsx';
import VoucherCodesOverview from '../components/organisms/VoucherCodesOverview/VoucherCodesOverview.tsx';

const components = new Map();
components.set('ActionButtonList', ActionButtonList);
components.set('ActionsStatistics', ActionsStatistics);
components.set('AddToBasket', AddToBasket);
components.set('BackToSearch', BackToSearch);
components.set('BasicImage', BasicImage);
components.set('BasicInformation', BasicInformation);
components.set('BasicText', BasicText);
components.set('Breadcrumb', Breadcrumb);
components.set('ButtonGroup', ButtonGroup);
components.set('CallToActionContent', CallToActionContent);
components.set('CallToActionImage', CallToActionImage);
components.set('ContentCard', ContentCard);
components.set('ContentModal', ContentModal);
components.set('DealerContactInformation', DealerContactInformation);
components.set('FindNearestDealerForm', FindNearestDealerForm);
components.set('FourColumnLayout', FourColumnLayout);
components.set('FourContentColumnLayout', FourContentColumnLayout);
components.set('GrayTopNavigationBar', GrayTopNavigationBar);
components.set('Grid', Grid);
components.set('GridCardContainer', GridCardContainer);
components.set('HeroBanner', HeroBanner);
components.set('HeroBannerWithCallToAction', HeroBannerWithCallToAction);
components.set('HeroBannerWithTitleAbove', HeroBannerWithTitleAbove);
components.set('HeroBannerWithUSP', HeroBannerWithUSP);
components.set('HeroImage', HeroImage);
components.set('HighlightedContentBlock', HighlightedContentBlock);
components.set('Iframe', Iframe);
components.set('LanguageSwitcher', LanguageSwitcher);
components.set('LoginOrRegister', LoginOrRegister);
components.set('LoyaltyPointBalanceBanner', LoyaltyPointBalanceBanner);
components.set('LoyaltyProgramLogo', LoyaltyProgramLogo);
components.set('Menu', Menu);
components.set('MenuList', MenuList);
components.set('MenuListAction', MenuListAction);
components.set('MenuResponsive', MenuResponsive);
components.set('MobileBreadcrumb', MobileBreadcrumb);
components.set('MyAccountNavigation', MyAccountNavigation);
components.set('Navigation', Navigation);
components.set('NoResults', NoResults);
components.set('OneColumnLayout', OneColumnLayout);
components.set('OneContentColumnLayout', OneContentColumnLayout);
components.set('Overlay', Overlay);
components.set('PaginationControls', PaginationControls);
components.set('PaginationPageNumbers', PaginationPageNumbers);
components.set('PartLine', PartLine);
components.set('PartPrice', PartPrice);
components.set('PartPromotions', PartPromotions);
components.set('PartnerTileList', PartnerTileList);
components.set('PlansAndOtherServices', PlansAndOtherServices);
components.set('ProductOrServiceTile', ProductOrServiceTile);
components.set('RemoveCategoryFilterButton', RemoveCategoryFilterButton);
components.set('RequestAccountSelectDealer', RequestAccountSelectDealer);
components.set('RequestAccountSelectedDealer', RequestAccountSelectedDealer);
components.set('ResponsiveWrapper', ResponsiveWrapper);
components.set('RewardsOverviewFilterControls', RewardsOverviewFilterControls);
components.set('RewardsRedeemRewardSidepanel', RewardsRedeemRewardSidepanel);
components.set('SearchBar', SearchBar);
components.set('SearchServicePartners', SearchServicePartners);
components.set('ServicePlansCoverageSummary', ServicePlansCoverageSummary);
components.set('ServicePlansCoverageSummaryBullets', ServicePlansCoverageSummaryBullets);
components.set('ServicePlansDetails', ServicePlansDetails);
components.set('SitecoreButton', SitecoreButton);
components.set('SitecoreLink', SitecoreLink);
components.set('SitecoreText', SitecoreText);
components.set('SocialShareButton', SocialShareButton);
components.set('SubNavigationMenu', SubNavigationMenu);
components.set('SummaryList', SummaryList);
components.set('Supersession', Supersession);
components.set('Tab', Tab);
components.set('Table', Table);
components.set('ThreeColumnLayout', ThreeColumnLayout);
components.set('ThreeContentColumnLayout', ThreeContentColumnLayout);
components.set('Title', Title);
components.set('TitleBar', TitleBar);
components.set('Toast', Toast);
components.set('Tooltip', Tooltip);
components.set('TwoColumnLayout', TwoColumnLayout);
components.set('TwoContentColumnLayout', TwoContentColumnLayout);
components.set('VehicleDetailNotifications', VehicleDetailNotifications);
components.set('VehicleGrid', VehicleGrid);
components.set('VehicleRmDocuments', VehicleRmDocuments);
components.set('VehicleSearch', VehicleSearch);
components.set('YouTubeVideo', YouTubeVideo);
components.set('AccountOverview', AccountOverview);
components.set('AnchorMenu', AnchorMenu);
components.set('ArticleHighlights', ArticleHighlights);
components.set('AssemblyBasicInformation', AssemblyBasicInformation);
components.set('AssemblyBillOfMaterial', AssemblyBillOfMaterial);
components.set('AssemblyImages', AssemblyImages);
components.set('CallToAction', CallToAction);
components.set('CallToActionCentered', CallToActionCentered);
components.set('CallToActionGridWithImage', CallToActionGridWithImage);
components.set('CallToActionWithImage', CallToActionWithImage);
components.set('CallToActionWithImageBase', CallToActionWithImageBase);
components.set('CompanyProfile', CompanyProfile);
components.set('ContentSlider', ContentSlider);
components.set('CookieConsent', CookieConsent);
components.set('CookieConsentBase', CookieConsentBase);
components.set('CookieConsentPopup', CookieConsentPopup);
components.set('DafPortalConnect', DafPortalConnect);
components.set('DealerContactInformationBanner', DealerContactInformationBanner);
components.set('DealerLocator', DealerLocator);
components.set('DealerPartBasicInformation', DealerPartBasicInformation);
components.set('DealerPartCrossReferences', DealerPartCrossReferences);
components.set('DealerPartImagesCarousel', DealerPartImagesCarousel);
components.set('DealerPartSpecifications', DealerPartSpecifications);
components.set('DoubleImageBlock', DoubleImageBlock);
components.set('EmptyGridBox', EmptyGridBox);
components.set('FactSheet', FactSheet);
components.set('FinancialProfile', FinancialProfile);
components.set('FindNearestDealer', FindNearestDealer);
components.set('FindNearestDealerBlock', FindNearestDealerBlock);
components.set('Footer', Footer);
components.set('GenericContentSlider', GenericContentSlider);
components.set('Header', Header);
components.set('HeroBannerWithPlaceholder', HeroBannerWithPlaceholder);
components.set('HybridLogin', HybridLogin);
components.set('ImageCarousel', ImageCarousel);
components.set('Impersonated', Impersonated);
components.set('KnowledgeBase', KnowledgeBase);
components.set('LoyaltyPointsBalance', LoyaltyPointsBalance);
components.set('MagazineCallToAction', MagazineCallToAction);
components.set('MagazineCover', MagazineCover);
components.set('MagazineProductHighlightDual', MagazineProductHighlightDual);
components.set('MagazineProductHighlightSingle', MagazineProductHighlightSingle);
components.set('MagazineProductHighlightTriple', MagazineProductHighlightTriple);
components.set('MagazineTestimonial', MagazineTestimonial);
components.set('MainNavigation', MainNavigation);
components.set('Modal', Modal);
components.set('MultiSupportDashboard', MultiSupportDashboard);
components.set('MultisupportUrgentTask', MultisupportUrgentTask);
components.set('MultisupportUrgentTasks', MultisupportUrgentTasks);
components.set('MyAccount', MyAccount);
components.set('MyFleetDashboard', MyFleetDashboard);
components.set('MyFleetList', MyFleetList);
components.set('NewsArticleCard', NewsArticleCard);
components.set('NewsArticleDetail', NewsArticleDetail);
components.set('NewsArticleHighlights', NewsArticleHighlights);
components.set('NewsArticleOverview', NewsArticleOverview);
components.set('NotificationBar', NotificationBar);
components.set('NotificationBarContent', NotificationBarContent);
components.set('Paginated', Paginated);
components.set('Pagination', Pagination);
components.set('PartAlternativeParts', PartAlternativeParts);
components.set('PartApplicationTable', PartApplicationTable);
components.set('PartApplications', PartApplications);
components.set('PartBasicInformation', PartBasicInformation);
components.set('PartBillOfMaterial', PartBillOfMaterial);
components.set('PartCrossReferences', PartCrossReferences);
components.set('PartCrossSellParts', PartCrossSellParts);
components.set('PartEnvironmentalInfo', PartEnvironmentalInfo);
components.set('PartImagesCarousel', PartImagesCarousel);
components.set('PartMaxCoupon', PartMaxCoupon);
components.set('PartMobileModalLink', PartMobileModalLink);
components.set('PartMostVisitedSlider', PartMostVisitedSlider);
components.set('PartPromotionsSlider', PartPromotionsSlider);
components.set('PartQuantumPrice', PartQuantumPrice);
components.set('PartSlider', PartSlider);
components.set('PartSpareParts', PartSpareParts);
components.set('PartSpecifications', PartSpecifications);
components.set('PartSpecificationsTable', PartSpecificationsTable);
components.set('PartStockInformationList', PartStockInformationList);
components.set('PartsNavigation', PartsNavigation);
components.set('PayWithPointsWrapper', PayWithPointsWrapper);
components.set('PersonalizedGreetingBanner', PersonalizedGreetingBanner);
components.set('PointsForMerchandiseWrapper', PointsForMerchandiseWrapper);
components.set('ProductsAndServices', ProductsAndServices);
components.set('ProgressBar', ProgressBar);
components.set('QuickLinks', QuickLinks);
components.set('RecommendedPartSlider', RecommendedPartSlider);
components.set('RequestAccount', RequestAccount);
components.set('RequestAccountDealer', RequestAccountDealer);
components.set('RequestMaintenancePlanWizard', RequestMaintenancePlanWizard);
components.set('RewardsOverview', RewardsOverview);
components.set('RewardsOverviewWrapper', RewardsOverviewWrapper);
components.set('SearchResults', SearchResults);
components.set('ShoppingBasket', ShoppingBasket);
components.set('ShoppingBasketOrderConfirmed', ShoppingBasketOrderConfirmed);
components.set('ShoppingBasketPartMostVisitedSlider', ShoppingBasketPartMostVisitedSlider);
components.set('ShoppingBasketRecommendedPartSlider', ShoppingBasketRecommendedPartSlider);
components.set('ShoppingBasketWizard', ShoppingBasketWizard);
components.set('SidePanel', SidePanel);
components.set('SitecoreForm', SitecoreForm);
components.set('Slider', Slider);
components.set('SlideshowHandout', SlideshowHandout);
components.set('SlideshowModal', SlideshowModal);
components.set('SocialShareButtons', SocialShareButtons);
components.set('StoreSwitcher', StoreSwitcher);
components.set('TeaserImageTextBlock', TeaserImageTextBlock);
components.set('Testimonial', Testimonial);
components.set('ToastWrapper', ToastWrapper);
components.set('UserSettings', UserSettings);
components.set('VehicleDetailFinance', VehicleDetailFinance);
components.set('VehicleDetailHeader', VehicleDetailHeader);
components.set('VehicleDetailMaintenance', VehicleDetailMaintenance);
components.set('VehicleDetailServicePlans', VehicleDetailServicePlans);
components.set('VehicleMaintenanceList', VehicleMaintenanceList);
components.set('VehicleRecallList', VehicleRecallList);
components.set('VehicleSearchBlock', VehicleSearchBlock);
components.set('VoucherCodesOverview', VoucherCodesOverview);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
